import React, { useEffect, useState } from 'react';
import Datatable from '../../components/Datatable';
import { Box } from '@mui/material';
import { useNotify } from '../../components/Datatable/NotifyProvider';
import LogFilters from '../../components/LogFilters';
import moment from "moment";
import 'moment/locale/pt-br';

export default function Session() {
    const notify = useNotify();
    const [refresh, setRefresh] = useState(false);

    // Default 24h pra sessões — em base com 10M+ linhas, sem range nada carrega.
    const [filters, setFilters] = useState({ preset: '24h' });
    const [applied, setApplied] = useState(filters);

    React.useEffect(() => {
        document.title = "IPV7 Tools - Gate Sessões";
    }, []);

    const buildExtra = (f) => {
        const out = {};
        if (f.preset && f.preset !== 'custom') out.preset = f.preset;
        if (f.preset === 'custom') {
            if (f.date_from) out.date_from = f.date_from;
            if (f.date_to)   out.date_to = f.date_to;
        }
        if (f.username) out.username = f.username;
        if (f.nas_ip)   out.nas_ip = f.nas_ip;
        if (f.status)   out.status = f.status;
        return out;
    };

    return (
        <Box>
            <LogFilters
                value={filters}
                onChange={setFilters}
                onApply={() => setApplied(filters)}
                showStatus
                showNas
            />
            <Datatable
                refresh={refresh}
                handlerRefresh={() => setRefresh(!refresh)}
                title='Logs de Sessões'
                endpoint='/radacct'
                extraFilters={buildExtra(applied)}
                options={{ search: false }}
                columns={[
                    { name: 'id', label: 'ID', options: { display: false } },
                    { name: 'username', label: 'Usuário' },
                    { name: 'nasipaddress', label: 'Equipamento' },
                    {
                        name: "framedipaddress",
                        label: "Origem do Acesso",
                        options: {
                            customBodyRender: (value, tableMeta) => {
                                const callingstationid = tableMeta.rowData[4];
                                return <span>{value ? value : callingstationid}</span>;
                            },
                        }
                    },
                    { name: "callingstationid", label: "Calling Station ID", options: { display: false } },
                    {
                        name: 'acctstarttime',
                        label: 'Data de Autenticação',
                        options: {
                            customBodyRender: value => <span>{moment(value).locale('pt-br').format('DD-MM-YYYY HH:mm:ss')}</span>,
                        }
                    },
                    {
                        name: 'acctstoptime',
                        label: 'Data de Desconexão',
                        options: {
                            customBodyRender: value => <span>{value ? moment(value).locale('pt-br').format('DD-MM-YYYY HH:mm:ss') : 'Ativo'}</span>,
                        }
                    },
                    {
                        name: "acctsessiontime",
                        label: "Tempo de Sessão",
                        options: {
                            customBodyRender: value => <span>{value ? moment.utc(value * 1000).format('HH:mm:ss') : 'Ativo'}</span>,
                        }
                    },
                ]}
            />
        </Box>
    );
}
